export default __webpack_public_path__ + "static/media/Cap of the Still Pond.5a10ca77.jpg";